import { lazy } from 'react'

import AppRouteInterface from 'src/types/AppRouteInterface'

// Where adomik_api sends the user back from Cognito.
export const COGNITO_CALLBACK_PATH = '/login/cognito'
// Where the intranet's one-time impersonation link lands (SNOW-8234).
export const KAGEMUSHA_PATH = '/login/kagemusha'

const publicRoutes: ReadonlyArray<AppRouteInterface> = [
  {
    path: '/login',
    component: lazy(
      () =>
        /* webpackMode: "lazy", webpackChunkName: "login_page" */
        import('src/components/ui/pages/public/LoginPage'),
    ),
  },
  {
    path: COGNITO_CALLBACK_PATH,
    component: lazy(
      () =>
        /* webpackMode: "lazy", webpackChunkName: "login_cognito_page" */
        import('src/components/ui/pages/public/CognitoCallbackPage'),
    ),
  },
  {
    path: KAGEMUSHA_PATH,
    component: lazy(
      () =>
        /* webpackMode: "lazy", webpackChunkName: "login_kagemusha_page" */
        import('src/components/ui/pages/public/KagemushaPage'),
    ),
  },
  {
    path: '/confirmation',
    component: lazy(
      () =>
        /* webpackMode: "lazy", webpackChunkName: "login_confirmation_page" */
        import('src/components/ui/pages/public/PasswordConfirmationPage'),
    ),
  },
  {
    path: '/forgotten',
    component: lazy(
      () =>
        /* webpackMode: "lazy", webpackChunkName: "login_forgotten_page" */
        import('src/components/ui/pages/public/ForgottenPasswordPage'),
    ),
  },
]

export default publicRoutes
